import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_k9wgg7d8ju: FaireBrandEntity = {
  token: "b_k9wgg7d8ju",
  type: "brand",
  name: "Mr. Papou's",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb8aedb948816095d5b4748ae1378a79bbfca9e781be350655d7a99aac468659.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e36f1e9546ba0877d46a3fb836fa258b224d61faabfdbf242cd252d63686aee2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bb8aedb948816095d5b4748ae1378a79bbfca9e781be350655d7a99aac468659.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e36f1e9546ba0877d46a3fb836fa258b224d61faabfdbf242cd252d63686aee2.jpeg",
  location: "Charlestown, NH, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Our story begins with our grandfather and his father in the hills outside of Corinth, Greece. Through their love of the land, they began a quest to produce some of the finest natural products that Greece had ever seen. They began small with only a few orchards and vineyards in the village of Poulitsa. Over the years, their quality product and honest characteristics became well known within Corinthian region. They began growing their operations and producing more fresh fruit and olive oil each year. A hundred years later, our family now owns thousands of olive trees and produces ample amounts of extra virgin olive oil each year.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.176Z",
    importedBy: "entity-db-cli",
  },
};
